var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBottomRightCornerPadded = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 292,
    viewBox: "0 0 100 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5801 8.5C68.4987 24.8207 81.3136 66.8165 81.3136 121.689L81.3136 126.54C81.3136 179.433 77.1966 232.246 69 284.5V284.5",
    stroke: "#4285F4",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4158 290.023L79.432 271.968L62.6006 269L67.4158 290.023Z",
    fill: "#4285F4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBottomRightCornerPadded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bottom_right_corner_padded.84d221c748f7393ad41cf6bf1e431d92.svg";